import { ResetForgottenPasswordState } from './resetForgottenPassword.types'

const initialState: ResetForgottenPasswordState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
